import { API } from "./api";

// First-party nav analytics — batched, fire-and-forget, consent-gated.
// Only sends when the visitor chose "accepted" in the cookie banner.

const CONSENT_KEY = "hc_cookie_consent";

function consented() {
    try {
        const cookieChoice = document.cookie.split("; ").find((c) => c.startsWith(`${CONSENT_KEY}=`))?.split("=")[1];
        return (cookieChoice || localStorage.getItem(CONSENT_KEY)) === "accepted";
    } catch {
        return false;
    }
}

let queue = [];
let timer = null;

function flush() {
    timer = null;
    const events = queue.splice(0);
    if (!events.length) return;
    const body = JSON.stringify({ events });
    const url = `${API}/nav/track`;
    try {
        const ok = navigator.sendBeacon?.(url, new Blob([body], { type: "application/json" }));
        if (ok) return;
    } catch { /* fall through */ }
    fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
}

export function trackNav(type, category, path = "", surface = "") {
    if (!consented()) return;
    queue.push({ type, category, path, surface });
    if (queue.length >= 10) {
        if (timer) clearTimeout(timer);
        flush();
        return;
    }
    if (!timer) timer = setTimeout(flush, 1500);
}
